import { TypeActionCardAction } from '@enums/type-actions-card.enum';
import { CreditCardType } from '@enums/type-credit-card.enum';

export interface IResponseCardViewModel {
  cardBrand: CreditCardType;
  cardHolderAddress: string;
  cardHolderCity: string;
  cardHolderCountryCode: string;
  cardHolderEmail: string;
  cardHolderPostalCode: string;
  cardHolderState: string;
  cardHolderDistrict: string;
  cardHolderIdentifier: string;
  provider: string;
  isDefault: boolean;
  cardId: string;
  cardHolderName: string;
  cardHolderLastName: string;
  last4: string;
  expMonth: number;
  expYear: number;
  cvv: string;
  cardImageUrl: string;
  expired: boolean;
  openOptions: boolean;
  cardBrandName: string;
  cardHolderStateCode: string;
}

export interface IResponseMinimalCard {
  cardId: string;
  expMonth: number;
  expYear: number;
  isDefault: boolean;
  cardImageUrl: string;
  last4: string;
  cardBrandName: string;
  expired: boolean;
  openOptions: boolean;
  provider: string;
  countryCode: string;
}
export interface IResponseMinimalCardWrapper {
  value:any[];
  errors: any[];
  success: boolean;
}
export interface ResponseCardModal {
  action: TypeActionCardAction;
  success: boolean;
  lastFourNumbers?: string;
}
export interface PreviewActionModal {
  title: string;
  subTitle: string;
  icon: string;
  classConfirmButton: string;
}
export interface Cardlist {
  textCard: string,
  date: string,
  cardId: string,
  textCardPlane: string,
  isDefault: boolean,
  countryCode: string,
}

export interface PaymentContent {
  contentId: string,
  planId: string,
  contentType: string,
  amount: number,
  isRent: boolean,
  rentalDays: string | number,
  userId: string,
  imageContent: string,
  title: string,
  action: string
}
